import { TemplateName, } from "./types";
// Import template classes for hydration
import { DefaultTemplate } from "./defaultTemplate";
import { TierIIEmailTemplate } from "./tierIIEmailTemplate";
import { OhioSercTemplate } from "./ohioSercTemplate";
import { MailRoomFlexibleTemplate } from "./mailRoomFlexibleTemplate";
/**
 * Gets a template instance by name
 */
export function getTemplate(templateName) {
    switch (templateName) {
        case TemplateName.TierIIEmailSingle:
        case TemplateName.TierIIEmailBulk:
        case TemplateName.TierIIEmail:
            return new TierIIEmailTemplate().toTemplate();
        case TemplateName.OhioSerc:
            return new OhioSercTemplate().toTemplate();
        case TemplateName.MailRoomFlexible:
            return new MailRoomFlexibleTemplate().toTemplate();
        case TemplateName.Default:
        default:
            return new DefaultTemplate().toTemplate();
    }
}
/**
 * Hydrates a template with communication data, returning the rendered subject and text.
 * This function works with any data source that matches the TemplateCommunication interface.
 */
export const hydrateTemplate = (templateName, communication) => {
    const template = getTemplate(templateName);
    const subject = template.subject({ communication });
    const text = template.text({ communication });
    return {
        subject,
        text,
        templateId: template.id,
    };
};
//# sourceMappingURL=hydrator.js.map